/**
 * @desc 多平台配置
 */
const mode = process.env.VUE_APP_MODE
// 是否是中大mtu测试站
const isMtu = process.env.VUE_APP_MTU
const isTest = process.env.VUE_APP_TEST
const isProd = process.env.VUE_APP_PROD
let platform = {}

switch (mode) {
  //中大sysu
  case 'sysu':
    platform = {
      baseUrl: isTest
        ? isMtu
          ? 'https://lms.sysu.mtu.plus'
          : 'http://172.22.43.202'
        : isProd
        ? 'https://lms.sysu.edu.cn'
        : '',
      baseUrlSuffix: isTest
        ? isMtu
          ? '/tj/backend/public/api'
          : '/sjtj/backend/public/api'
        : isProd
        ? '/sjtj/backend/public/api'
        : '/tj/backend/public/api',
      callbackUrl: isTest
        ? isMtu
          ? 'https://lms.sysu.mtu.plus/tj/backend/public/api/moodle/index'
          : 'http://172.22.43.202/sjtj/backend/public/api/moodle/index'
        : isProd
        ? 'https://lms.sysu.edu.cn/sjtj/backend/public/api/moodle/index'
        : '',
    }
    break
  //ils
  case 'ils':
    {
      platform = {
        baseUrl: 'https://ils.wakeychan.com',
        baseUrlSuffix: '/stats/public/api',
        callbackUrl: 'https://ils.wakeychan.com/stats/public/api/moodle/index',
      }
    }
    break
  //南方医nfyku
  case 'nfyku':
    {
      platform = {
        baseUrl: 'https://aike.smu.edu.cn',
        baseUrlSuffix: '/sjtj/backend/public/api',
        callbackUrl: 'https://aike.smu.edu.cn/sjtj/backend/public/api/moodle/index',
      }
    }
    break
  //华师
  case 'scnu':
    {
      platform = {
        baseUrl: 'https://moodle.scnu.edu.cn',
        baseUrlSuffix: '/sjtj/backend/public/api',
        callbackUrl: 'https://moodle.scnu.edu.cn/sjtj/backend/public/api/moodle/index',
      }
    }
    break
  //广开站
  case 'gk':
    {
      platform = {
        baseUrl: 'http://120.77.156.199',
        baseUrlSuffix: '/sjtj/backend/public/api',
        callbackUrl: 'http://120.77.156.199/sjtj/backend/public/api/moodle/index',
      }
    }
    break
  //广工
  case 'gdut':
    {
      platform = {
        baseUrl: 'https://courses.gdut.edu.cn',
        baseUrlSuffix: '/sjtj/backend/public/api',
        callbackUrl: 'https://courses.gdut.edu.cn/sjtj/backend/public/api/moodle/index',
      }
    }
    break
  //moodle_iscnu
  case 'moodleIscnu':
    {
      platform = {
        baseUrl: 'https://moodle.iscnu.net',
        baseUrlSuffix: '/sjtj/backend/public/api',
        callbackUrl: 'https://moodle.iscnu.net/sjtj/backend/public/api/moodle/index',
      }
    }
    break
}
module.exports = platform
